var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('div',{staticClass:"ifram"},[_c('iframe',{ref:"dynamicIframe",attrs:{"id":"iframe","src":_vm.url,"width":"100%","frameborder":"0","height":"1635"}})]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }